import React from 'react'
import { config } from 'config'
import { rhythm } from 'utils/typography'
import { prefixLink } from 'gatsby-helpers'
import defaultPic from './default-pic.png'
import styles from './GalleryItem.module.scss'
import { Link } from 'react-router'

class GalleryItem extends React.Component {
  
  static propTypes () {
    return {
      data: React.PropTypes.object,
      onClick: React.PropTypes.func,
    }
  }

  render () {
    const data = this.props.data;
    const src = this.props.data.src || defaultPic;
    return (
      <div className={styles.galleryItem} onClick={() => {this.props.onClick(data)}}>
        <img src={prefixLink(src)} />
        <p>{data.caption}</p>
      </div>
    )
  }
}

export default GalleryItem



/** WEBPACK FOOTER **
 ** ../components/GalleryItem.js
 **/